<template>
  <div class="videoLearn">
    <vsmallheader></vsmallheader>
    <div class="header">
      <div
        style="width: 1200px;margin: 0 auto;margin-top:15px;display:flex;align-items: center;padding-bottom:15px;font-size:14px"
      >
        <div style="font-size:14px;color:#888;display:flex;align-items: center">
          <img src="@/assets/resource/adresst.png" style="width:15px;height:15px;margin-right:5px" />
          当前位置：
        </div>
        <span @click="retrun" style="cursor: pointer;font-size: 14px;">资源管理 / {{dataForm.name}}</span>
      </div>
      <div class="headerbox">
        <div style="position: relative;">
          <div
            ref="tabx1"
            style="width:100%;height:100%"
            class="videoPot"
            v-if="dataForm.documentType==2"
          >
            <video-player
              v-if="dataForm.documentType==2"
              :class="['vjs-custom-skin']"
              style="object-fit: cover"
              ref="videoPlayer"
              :fluid="true"
              :options="playerOptions"
              :playsinline="false"
              :fullSreen="true"
              @play="onPlayerPlay($event)"
              @pause="onPlayerPause($event)"
              @ended="onPlayerEnded($event)"
              @timeupdate="onPlayerTimeupdate($event)"
            ></video-player>
            <vue-baberrage
              :isShow="barrageIsShow"
              :boxWidth="1200"
              :barrageList="barrageList"
              :loop="barrageLoop"
              style="position: absolute; top: 0;left: 0;height:200px"
            ></vue-baberrage>
            <div class="next-box" v-show="visShow">
              <div class="replayclas">当前视频已看完！</div>
            </div>

            <div class="next-box" v-show="recordshow">
              上次播放到{{ playtiembl}}，
              <el-button type="success" round @click="toContinue">继续播放</el-button>
              <el-button type="primary" round @click="restart">重新开始</el-button>
            </div>


	          <div class="gift-list">
		          <div class="gift-item" data-type="heart" data-name="爱心" data-price="10">
			          <div class="icon-wrapper" style="background-color: rgba(255, 59, 48, 0.2);">
				          <i class="fa fa-heart" style="color: #ff3b30; font-size: 24px;"></i>
			          </div>
			          <span>爱心</span>
		          </div>

		          <div class="gift-item" data-type="star" data-name="星星" data-price="5">
			          <div class="icon-wrapper" style="background-color: rgba(255, 204, 0, 0.2);">
				          <i class="fa fa-star" style="color: #ffcc00; font-size: 24px;"></i>
			          </div>
			          <span>星星</span>
		          </div>
	          </div>
          </div>

          <iframe
            :src="pdfUrl"
            frameborder="0"
            width="1200"
            height=" 648;"
            v-else-if="dataForm.documentType==1"
          ></iframe>
          <div class="ras-time" v-if="hideDiaolog&&dataForm.documentType==1">{{learnTimes}}</div>

          <div
            v-else-if="dataForm.documentType==4"
            style="text-align: center;padding:30px; min-height: 400px"
            class="audioclass"
          >
            <!-- <div style="font-size:24px">音频名称:{{dataForm.name}}</div> -->
            <div>
              <audio controls style="margin-top:10px;">
                <!-- <source src="horse.ogg" type="audio/ogg"> -->
                <source :src="ipUrl + dataForm.filePath" type="audio/mpeg" />
              </audio>
            </div>
          </div>

          <div
            v-else-if="dataForm.documentType==3"
            style="text-align: center; min-height: 400px"
            class="audioclass"
          >
            <!-- <div style="font-size:24px">图片名称:{{dataForm.name}}</div> -->
            <div style="width: 100%;text-align: center;">
              <img :src="ipUrl + dataForm.filePath" alt style=" max-width: 100%;max-height: 100%;" />
            </div>
          </div>
        </div>
        <div class="icon">
          <!-- <div class="txIcon">提醒：视频要完全播放完后，才可以产生积分，培训班的学习任务才会显示已学习.</div> -->
          <div class="txIcon">已观看次数：{{dataForm.visitNum}}</div>
          <div class="iconright">
            <div @click="give()" class="videimg" style="cursor: pointer;">
              <img src="@/assets/resource/taklles.png" alt v-if="giveflag==false" />
              <img src="@/assets/resource/takllesActive.png" alt v-else />
              {{dataForm.assistCount}}
              <!-- {{dataForm.talkCount}} -->
            </div>
            <div @click="collect()" class="videimg" style="cursor: pointer;">
              <img src="@/assets/resource/colles.png" alt v-if="collectflag==false" />
              <img src="@/assets/resource/collesActive.png" alt v-else />
              {{dataForm.collectionCount}}
              <!-- {{dataForm.assistCount}} -->
            </div>
            <div
              @click="downloadres(dataForm)"
              class="videimgs"
              style="cursor: pointer;color:#1492ff"
              v-if="dataForm.isDown"
            >
              <img src="@/assets/videoimg/download.svg" alt />
              下载
            </div>
            <div
              @click="downloadresNone(dataForm)"
              class="videimg"
              style="cursor: not-allowed;color:#999"
              v-else
            >
              <img src="@/assets/videoimg/download.svg" alt />
              下载
            </div>
            <div
              class="vidojl"
              style="cursor: pointer;color:#1492ff"
              @click="hcanvas"
              v-if="dataForm.documentType==2"
            >记录</div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div style="display:flex;align-items: center;width:1200px;margin:0 auto">
      <div class="display:flex;align-items: center">
        <el-input type="text" style="width:250px" placeholder="请输入弹幕" v-model="msgTitle"></el-input>
        <el-button type="success" @click="addToList" style="margin-left:10px">确定</el-button>
      </div>
    </div>-->

    <div class="matter">
      <div class="matterbox">
        <template>
          <v-video-review :dataForm="dataForm"></v-video-review>
        </template>

        <div>
          <template>
            <v-popular-resources></v-popular-resources>
          </template>
        </div>
      </div>
    </div>
    <!-- <linecom></linecom> -->
    <!-- <el-dialog
      :visible.sync="showdiaLog"
      :close-on-click-modal="false"
      center
      :show-close="false"
      width="400px">
      <div class="learn-time">学习时间必须达到：{{learnTimes}}s</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitTime">确 定</el-button>
      </span>
    </el-dialog>-->
  </div>
</template>
<script>
import { getInfo } from '@/utils/auth';
import linecom from '@/components/linecom/index';
import vsmallheader from '@/views/smallHeader/index';
import * as resourceInfo from '@/api/resources/index.js';

import * as givecollect from '@/api/public.js';
import * as ApiPerson from '@/api/personcenter/index';
import vVideoReview from './components/videoReview/index.vue';
import vPopularResources from './components/popularResources/index';
import html2Canvas from 'html2canvas';
import Vue from 'vue';
import { vueBaberrage } from 'vue-baberrage';
Vue.use(vueBaberrage);
import { MESSAGE_TYPE } from 'vue-baberrage';
// import vPdfDom from './components/pdfDom/index';

import VideoPlayer from 'vue-video-player';
window.videojs = VideoPlayer.videojs;
require('video.js/dist/lang/zh-CN.js');
require('video.js/dist/video-js.css');
require('vue-video-player/src/custom-theme.css');
import 'videojs-flash'; //引入才能播放rtmp视屏
import 'videojs-contrib-hls'; //引入才能播放m3u8文件
Vue.use(VideoPlayer);
export default {
  components: {
    vVideoReview,
    vPopularResources,
    // vPdfDom,
    vsmallheader,
    linecom,
  },
  data() {
    return {
      playtiembl: '',
      barrageIsShow: true,
      currentId: 0,
      barrageLoop: false,
      barrageList: [],
      msgTitle: '',
      recordshow: false,
      learnTime: 0,
      playTime: 0,
      record: '',
      isOver: null,
      countdown: 5,
      timer: null,
      visShow: false,
      resourceId: this.$route.query.id,
      dataForm: {},
      giveflag: '',
      collectflag: '',
      gklog: 0,
      pdfUrl: '',
      videoComplete: false,
      playerOptions: {
        objectFit: 'contain',
        height: '540px',
        size: '100%',
        autoplay: false,
        muted: false,
        language: 'en',
        webkitPlaysinline: 'true',
        language: 'zh-CN',
        playbackRates: [0.5, 1.0, 1.5, 2.0],

        sources: [
          {
            src: '',
          },
        ],
        presentTiem: '',
        videoStepId: '',
        trainId: this.$route.query.trainId ? this.$route.query.trainId : 0,
      },
      showdiaLog: false,
      learnTimes: 60,
      hideDiaolog: false,

      timer: null,
      countDownNum: 60,
      ipUrl:"",
    };
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
  },
  created() {
 
    this.trainId = this.$route.query.trainId ? this.$route.query.trainId : 0;
    // console.log(getInfo('tokens'));

    this.DocumentRecordList();
    // 判断是否登录
    if (getInfo('tokens')) {
      this.whethergive();
      this.whethercollect();
     
    }
    
  },
  beforeDestroy() {
    //退出时销毁播放器，否则第二次进去不来
    if (this.dataForm.documentType == 2) {
      let player = videojs('videoPlayer');
      player.dispose();
    }
  },
  methods: {
    // 添加学习记录
    hcanvas() {
      let _this = this;
      let times = this.gklog;
      if (getInfo('tokens')) {
        let video = document.getElementsByClassName('vjs-tech')[0];
        let canvas = document.createElement('canvas');
        let w = 1200;
        let h = 540;
        canvas.width = w;
        canvas.height = h;
        console.log(canvas);
        const ctx = canvas.getContext('2d');
        ctx.drawImage(video, 0, 0, w, h); // ctx.drawImage(video, 0, 0, w, h);
        let previewImg = canvas.toDataURL('image/png');
        this.beforeUpload(previewImg, times);
      } else {
        window.clikLogin();
      }
    },
    // base64转二级制
    beforeUpload(base64String, times) {
      //这里对base64串进行操作，去掉url头，并转换为byte
      var bytes = window.atob(base64String.split(',')[1]);
      //处理异常，将ASCII码小于0的转换为大于0，这里有两种写法
      var ab = new ArrayBuffer(bytes.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i); //这里有点疑惑，ia是怎么改变ab的？注：①
      }
      //Blob对象
      var blob = new Blob([ab], { type: 'image/jpeg' }); //type为图片的格式
      //FormData对象
      var fd = new FormData();
      //TDOD Ajax或者其他方式上传FormData对象
      //FormData对象接受三个参数，第三个参数为文件名，通常我们只传前两个参数，第三个参数不传则使用默认文件名，这里使用的Blob对象，所以需要一个文件名，用时间戳代替。
      fd.append('file', blob, Date.now() + '.jpg');

      givecollect.uploadDoc(fd).then((res) => {
        // console.log(res);
        if (res.result) {
          let data = {
            userId: JSON.parse(getInfo('infos')).id,
            documentId: this.resourceId,
            times: Math.floor(times),
            imgUrl: res.result,
          };
          console.log(data);
          resourceInfo.AddNoteRecord(data).then((res) => {
            // console.log(res);
            this.$message.success('成功');
          });
        }
      });
    },
    retrun() {
      // 如果是从个人中心入的，就需要返回个人中心，如果过是首页进入的就直接调回首页
      if (localStorage.getItem('fullPath') == '/personCenter') {
        this.$router.go(-1);
      } else if (localStorage.getItem('fullPath') == '/home') {
        this.$router.go(-1);
      } else if (localStorage.getItem('fullPath') == '/mooc') {
        this.$router.go(-1);
      } else {
        this.$router.push('/sourceslist');
      }
    },
    // 查询播放记录 DocumentRecordGet
    DocumentRecordList() {
     
      let userId=0;
      if(getInfo('infos'))
      {
        userId=JSON.parse(getInfo('infos')).id;
      }
    
      let data = {
        documentId: this.resourceId,
        userId: userId,
        trainId: this.trainId,
      };
      resourceInfo.DocumentRecordGet(data).then((res) => {
        // console.log(res.result);
        // console.log('查询播放记录');
        if (res.result.length != 0) {
          this.isOver = res.result[0].isOver;
          this.playTime = res.result[0].playTime;
          this.getsecondMinute(this.playTime);
        }
        //播放前去请求下地址
       this.beforeGetList(); 
      });
    },
    // 秒化成分钟
    getsecondMinute(value) {
      let result = parseInt(value);
      let h =
        Math.floor(result / 3600) < 10
          ? '0' + Math.floor(result / 3600)
          : Math.floor(result / 3600);
      let m =
        Math.floor((result / 60) % 60) < 10
          ? '0' + Math.floor((result / 60) % 60)
          : Math.floor((result / 60) % 60);
      let s =
        Math.floor(result % 60) < 10
          ? '0' + Math.floor(result % 60)
          : Math.floor(result % 60);
      if (h == 0 && m != 0) {
        this.playtiembl = m + '分' + s + '秒';
      } else if (m == 0 && h == 0) {
        this.playtiembl = s + '秒';
      } else if (h != 0) {
        this.playtiembl = h + '时' + m + '分' + s + '秒';
      }
    },
    // 继续播放
    toContinue() {
      this.recordshow = false;
      this.$refs.videoPlayer.player.currentTime(this.playTime); //插入当前卡点的时间
      this.$refs.videoPlayer.player.play();
    },
    // 重新开始
    restart() {
      this.learnTime = 0;
      this.recordshow = false;
      this.$refs.videoPlayer.options.autoplay = true;
      this.$refs.videoPlayer.player.play();
    },
    //拉取数据前
    beforeGetList(){
      resourceInfo.getDocumentIp().then(res=>{
        if(res.code == 200){
          this.ipUrl = res.result;
          this.getList();
        }else{
          this.$message({
                message: res.message,
                type: 'error',
              });
        }
      })
    },
    getList() {
      let ipUrl = this.ipUrl;
      resourceInfo.DocumentGetDetail({ id: this.resourceId }).then((res) => {
        //console.log(res.result[0]);
        this.dataForm = res.result[0];
        if (this.dataForm.documentType == 2) {
          if (this.isOver == false && this.playTime > 5) {
            this.playerOptions.sources[0].src = ipUrl + this.dataForm.filePath;
            this.recordshow = true;
          } else {
            this.$nextTick(() => {
              this.playerOptions.sources[0].src = ipUrl + this.dataForm.filePath;
              this.$refs['videoPlayer'].options.autoplay = true;
              this.$refs['videoPlayer'].player.play();
              if (this.dataForm.zimu) {
                setTimeout(() => {
                  this.barrageList.push({
                    id: ++this.currentId,
                    msg: this.dataForm.zimu,
                    time: 5,
                    type: MESSAGE_TYPE.NORMAL,
                  });
                }, 1500);
              }
            });
          }
        }

        if (this.dataForm.documentType == 1) {
          this.pdfUrl =
            '/pdf/web/viewer.html?file=' +
            encodeURIComponent( ipUrl + this.dataForm.filePath) +
            '&isdown=' +
            this.dataForm.isDown;
          this.showdiaLog = true;
        }
        if (this.dataForm.documentType > 2) {
          // this.addCourserecord(true);
          this.countDown(); //调用倒计时，看了60秒才能算看完
        }
      });
    },
    // 倒计时
    countDown() {
      this.timer = setInterval(() => {
        this.countDownNum--;
        if (this.countDownNum <= 0) {
          this.addCourserecord(true);
          clearInterval(this.timer);
        }
      }, 1000);
    },
    // 添加播放记录
    addCourserecord(isOver) {
      let data = {
        userId: Number(
          JSON.parse(getInfo('infos')).id ? JSON.parse(getInfo('infos')).id : 0
        ),
        trainId: this.trainId ? this.trainId : 0,
        documentId: Number(this.resourceId), //资源id
        fileType: this.dataForm.documentType, //类型
        isOver: isOver,
      };

      if (this.dataForm.documentType == 2) {
        data.playTime = Math.floor(this.gklog); //播放时长
        if (this.learnTime > 4) {
          let learnTime = Math.floor(this.learnTime) / 4;
          //记录学习时长
          data.learnTime = Math.floor(learnTime) - 2;
        }
      }
      if (data.userId != 0) {
        resourceInfo.DocumentRecordst(data).then((res) => {
          // console.log(res);
          // console.log('播放记录');
        });
      }
    },
    // 视频开始
    onPlayerPlay(player) {
      console.log(player);
    },
    // 视频暂停
    onPlayerPause(player) {},
    // 视频结束事件
    onPlayerEnded(player) {
      this.videoComplete = true;
      if (this.isOver != true && this.gklog > 5) {
        //有记录的情况下才插入记录
        this.addCourserecord(true); //插入视频记录
      }
      if (this.trainId) {
        this.getLearnOver();
      }
      this.visShow = true;
      this.sendCode();
    },
    getLearnOver() {
      let para = {
        userId: Number(
          tJSON.parse(getInfo('infos')).id ? JSON.parse(getInfo('infos')).id : 0
        ),
        trainId: this.trainId ? this.trainId : 0,
      };
      ApiPerson.getLearnOver(para).then((res) => {});
    },
    //监听播放器时间
    onPlayerTimeupdate(player) {
      this.gklog = player.currentTime();
      this.learnTime++;

      // let olbTiem = localStorage.getItem('videoTiem');
      // if (Number(this.gklog) - Number(olbTiem) > 60) {
      //   this.$refs.videoPlayer.player.currentTime(olbTiem); //插入当前卡点的时间
      //   this.$refs.videoPlayer.player.play();
      // }

      // localStorage.setItem('videoTiem', this.gklog);
    },
    // 判断是否点赞
    whethergive() {
      let para = {
        objId: this.$route.query.id,
        objType: 1,
        userId: JSON.parse(getInfo('infos')).id,
      };
      givecollect.AssistIsAssist(para).then((res) => {
        this.giveflag = res.result;
      });
    },
    //判断是否收藏
    whethercollect() {
      let para = {
        objId: this.$route.query.id,
        objType: 1,
        userId: JSON.parse(getInfo('infos')).id,
      };
      givecollect.CollectionIsColl(para).then((res) => {
        this.collectflag = res.result;
      });
    },
    give() {
      if (getInfo('tokens')) {
        if (this.giveflag == false) {
          //添加点赞
          let para = {
            objType: 1,
            objId: this.$route.query.id * 1,
            createId: JSON.parse(getInfo('infos')).id,
          };
          givecollect.AssistAdd(para).then((res) => {
            this.$message({
              message: '点赞成功',
              type: 'success',
            });
            this.whethergive();
            this.dataForm.assistCount = this.dataForm.assistCount + 1;
          });
        } else {
          //取消点赞
          let para = {
            objType: 1,
            objId: this.$route.query.id,
            userId: JSON.parse(getInfo('infos')).id,
          };
          givecollect.AssistDelete(para).then((res) => {
            this.whethergive();
            this.$message({
              message: '取消点赞成功',
              type: 'success',
            });
            this.dataForm.assistCount = this.dataForm.assistCount - 1;
          });
        }
      } else {
        window.clikLogin();
      }
    },
    //播放下一个倒计时
    sendCode() {
      this.loading(); //启动定时器
      this.timer = setInterval(() => {
        //创建定时器
        if (this.countdown === 1) {
          this.clearTimer(); //关闭定时器

          this.visShow = false;
        } else {
          this.loading();
        }
      }, 1000);
    },
    loading() {
      //启动定时器
      this.countdown--; //定时器减1
    },
    clearTimer() {
      //清除定时器
      clearInterval(this.timer);
      this.timer = null;
    },
    collect() {
      if (getInfo('tokens')) {
        if (this.collectflag == false) {
          //添加收藏
          let para = {
            objType: 1,
            objId: this.$route.query.id * 1,
            createId: JSON.parse(getInfo('infos')).id,
          };
          givecollect.CollectionAdd(para).then((res) => {
            this.$message({
              message: '收藏成功',
              type: 'success',
            });
            this.whethercollect();
            this.dataForm.collectionCount = this.dataForm.collectionCount + 1;
          });
        } else {
          //取消收藏
          let para = {
            objType: 1,
            objId: this.$route.query.id,
            userId: JSON.parse(getInfo('infos')).id,
          };
          givecollect.CollectionDele(para).then((res) => {
            this.whethercollect();
            this.$message({
              message: '取消收藏成功',
              type: 'success',
            });
            this.dataForm.collectionCount = this.dataForm.collectionCount - 1;
          });
        }
      } else {
        window.clikLogin();
      }
    },
    downloadres(dataForm) {
      let data = { id: dataForm.id };
      resourceInfo.Download(data).then((res) => {
        // console.log(res);
        // console.log(dataForm.documentpath);
        let a = document.createElement('a');
        a.setAttribute('download', dataForm.name);
        a.setAttribute('target', '_blank');
        a.setAttribute('href', dataForm.documentpath);
        a.click();
      });
    },
    downloadresNone() {},
  },

  // 页面销毁的时候插入记录
  beforeDestroy() {
    clearInterval(this.timer); //销毁倒计时
    if (this.dataForm.documentType == 2) {
      if (this.isOver != true && this.gklog > 5) {
        this.addCourserecord(false); //插入视频记录
      }
    }
    window.removeEventListener('beforeunload', (e) => this.beforeunloadFn(e));
  },
};
</script>
<style scoped>
/* 视频pdf区域 */
.header {
  width: 100%;
}
.headerbox {
  width: 1200px;
  margin: 0 auto;
  border: 1px solid #f2f2f2;
}

.headerbox > div:nth-child(2) {
  height: 64px;
}
.icon {
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #f2f2f2;
}
.iconleft {
  display: flex;
  margin-left: 100px;
}
.iconleft > div:nth-child(1) {
  margin-top: 15px;
  width: 30px;
  height: 30px;
  background-size: contain;
  background-image: url('../../../assets/resource/u231.svg');
  background-repeat: no-repeat;
}
.iconleft > div:nth-child(2) {
  margin-top: 22px;
  width: 30px;
  height: 30px;
  margin-left: 12px;
}
.iconleft > div:nth-child(3) {
  margin-top: 19px;
  margin-left: 30px;
  width: 25px;
  height: 25px;
  background-size: contain;
  background-image: url('../../../assets/resource/u234.svg');
  background-repeat: no-repeat;
}
.iconleft > div:nth-child(4) {
  margin-top: 22px;
  width: 30px;
  height: 30px;
  margin-left: 12px;
}
.iconright {
  display: flex;
  align-items: center;
}
.iconright > div {
  margin-right: 40px;
}
.iconright > div > img {
  margin-right: 5px;
  width: 25px;
  height: 25px;
  vertical-align: middle;
}
.videimg {
  display: flex;
  align-items: center;
}
.matterbox {
  width: 1200px;
  margin: 0 auto;
  margin-top: 30px;
  display: flex;
  justify-content: space-around;
}
.matterbox > div:nth-child(1) {
  width: 875px;
  min-height: 400px;
  margin-right: 30px;
}
.matterbox > div:nth-child(2) {
  width: 300px;

  /* margin-left: 100px; */

  border: 1px solid #f2f2f2;
}
.videoPot {
  position: relative;
}
.next-box {
  position: absolute;
  z-index: 999;
  border-radius: 20px;
  width: 100%;
  height: 540px;
  color: #fff;
  background-color: rgb(8, 8, 8);
  text-align: center;
  border-radius: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
}
.replayclas {
  color: #8cb822;
  font-size: 18px;
}
.txIcon {
  line-height: 64px;
  color: #6d6b6b;
  font-size: 14px;
  padding-left: 20px;
}
.audioclass {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #aaa;
}
.videimgs {
  display: flex;
  align-items: center;
}
.videimgs:hover,
.vidojl:hover {
  text-decoration: underline;
  color: #1492ff;
}
.learn-time {
  text-align: center;
  font-weight: 700;
  font-size: 18px;
}
.ras-time {
  width: 50px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  background-color: #999999;
  color: white;
  font-size: 18px;
  font-weight: 700;
  border-radius: 50%;
  position: absolute;
  top: 50px;
  left: 50%;
}
</style>
<style scoped>
* {
	margin: 0;
	padding: 0;
	box-sizing: border-box;
	font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

body {
	background-color: #1a1a1a;
	color: #ffffff;
	min-height: 100vh;
	display: flex;
	flex-direction: column;
}

/* 直播区域样式 */
#liveArea {
	flex: 1;
	position: relative;
	overflow: hidden;
}

#liveArea img {
	width: 100%;
	height: 100%;
	object-fit: cover;
	opacity: 0.8;
}

.live-overlay {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: linear-gradient(to top, rgba(26, 26, 26, 0.8) 0%, transparent 100%);
}

.like-counter {
	position: absolute;
	top: 15px;
	left: 15px;
	background-color: rgba(0, 0, 0, 0.5);
	padding: 8px 15px;
	border-radius: 20px;
	display: flex;
	align-items: center;
	font-weight: bold;
}

.like-counter i {
	color: #ff3b30;
	margin-right: 8px;
}

#effectContainer {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	overflow: hidden;
}

/* 互动区域样式 */
.interaction-area {
	background-color: #2c2c2c;
	padding: 15px;
	border-top: 1px solid #444444;
}

.interaction-container {
	max-width: 1200px;
	margin: 0 auto;
}

.quick-actions {
	display: flex;
	justify-content: center;
	gap: 30px;
	margin-bottom: 20px;
}

.action-btn {
	cursor: pointer;
	display: flex;
	flex-direction: column;
	align-items: center;
	transition: transform 0.2s, filter 0.2s;
}

.action-btn:hover {
	transform: scale(1.1);
	filter: brightness(1.2);
}

.action-btn .icon-wrapper {
	width: 45px;
	height: 45px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 5px;
}

.gifts-title {
	font-size: 18px;
	font-weight: bold;
	margin-bottom: 15px;
}

.gift-list {
	display: flex;
	gap: 25px;
	margin-bottom: 20px;
	overflow-x: auto;
	padding-bottom: 10px;
}

.gift-item {
	cursor: pointer;
	display: flex;
	flex-direction: column;
	align-items: center;
	min-width: 80px;
	transition: transform 0.2s;
}

.gift-item:hover {
	transform: scale(1.1);
}

.gift-item .icon-wrapper {
	width: 55px;
	height: 55px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 5px;
}

.gift-item.selected {
	outline: 2px solid #ff3b30;
	border-radius: 8px;
	padding: 5px;
}

.send-btn {
	background-color: #ff3b30;
	color: white;
	border: none;
	width: 100%;
	padding: 12px;
	border-radius: 25px;
	font-size: 16px;
	font-weight: bold;
	cursor: pointer;
	transition: background-color 0.2s;
}

.send-btn:hover {
	background-color: #e02e24;
}

/* 特效元素样式 */
.effect-element {
	position: absolute;
	pointer-events: none;
	z-index: 100;
}

.message-notification {
	position: absolute;
	top: 15px;
	right: 15px;
	background-color: rgba(0, 0, 0, 0.7);
	padding: 5px 12px;
	border-radius: 4px;
	font-weight: bold;
}

/* 动画定义 */
@keyframes floatUp {
	0% { transform: translateY(0); opacity: 1; }
	100% { transform: translateY(-500px); opacity: 0; }
}

@keyframes floatUpRotate {
	0% { transform: translateY(0) rotate(0deg); opacity: 1; }
	100% { transform: translateY(-500px) rotate(720deg); opacity: 0; }
}

@keyframes scaleIn {
	0% { transform: scale(0); opacity: 0; }
	50% { transform: scale(1.2); opacity: 1; }
	100% { transform: scale(1); opacity: 1; }
}

@keyframes slideIn {
	0% { transform: translateX(-100px); opacity: 0; }
	20% { transform: translateX(0); opacity: 1; }
	80% { transform: translateX(0); opacity: 1; }
	100% { transform: translateX(100vw); opacity: 0; }
}

@keyframes likePulse {
	0% { transform: scale(0); opacity: 1; }
	50% { transform: scale(1.3); opacity: 1; }
	100% { transform: scale(1); opacity: 0; }
}

@keyframes petalFloat {
	0% { transform: translate(0, 0) rotate(0deg); opacity: 1; }
	100% { transform: translate(var(--x-offset), var(--y-offset)) rotate(360deg); opacity: 0; }
}

.like-animation {
	animation: likePulse 0.6s cubic-bezier(0.17, 0.89, 0.32, 1.49) forwards;
}
</style>